// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.error-boundary {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  background: linear-gradient(135deg, #1a1a2e 0%, #16213e 50%, #0f3460 100%);
}

.error-boundary-content {
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
  border-radius: 20px;
  padding: 40px;
  max-width: 600px;
  text-align: center;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.error-boundary-content h1 {
  color: var(--christmas-gold);
  font-size: 2rem;
  margin-bottom: 20px;
}

.error-boundary-content p {
  color: white;
  font-size: 1.1rem;
  margin-bottom: 30px;
}

.error-details {
  background: rgba(0, 0, 0, 0.3);
  border-radius: 8px;
  padding: 15px;
  margin: 20px 0;
  text-align: left;
  color: rgba(255, 255, 255, 0.8);
}

.error-details summary {
  cursor: pointer;
  color: var(--christmas-gold);
  font-weight: bold;
  margin-bottom: 10px;
}

.error-details pre {
  white-space: pre-wrap;
  word-wrap: break-word;
  font-size: 0.9rem;
  margin: 10px 0;
}

.btn {
  padding: 12px 24px;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.btn-primary {
  background: linear-gradient(135deg, var(--christmas-red), #d32f2f);
  color: white;
  box-shadow: 0 4px 15px rgba(196, 30, 58, 0.4);
}

.btn-primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(196, 30, 58, 0.6);
}

`, "",{"version":3,"sources":["webpack://./src/components/Common/ErrorBoundary.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,0EAA0E;AAC5E;;AAEA;EACE,oCAAoC;EACpC,2BAA2B;EAC3B,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,yCAAyC;EACzC,0CAA0C;AAC5C;;AAEA;EACE,4BAA4B;EAC5B,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,qBAAqB;EACrB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,kEAAkE;EAClE,YAAY;EACZ,6CAA6C;AAC/C;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;AAC/C","sourcesContent":[".error-boundary {\n  min-height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 20px;\n  background: linear-gradient(135deg, #1a1a2e 0%, #16213e 50%, #0f3460 100%);\n}\n\n.error-boundary-content {\n  background: rgba(255, 255, 255, 0.1);\n  backdrop-filter: blur(10px);\n  border-radius: 20px;\n  padding: 40px;\n  max-width: 600px;\n  text-align: center;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n}\n\n.error-boundary-content h1 {\n  color: var(--christmas-gold);\n  font-size: 2rem;\n  margin-bottom: 20px;\n}\n\n.error-boundary-content p {\n  color: white;\n  font-size: 1.1rem;\n  margin-bottom: 30px;\n}\n\n.error-details {\n  background: rgba(0, 0, 0, 0.3);\n  border-radius: 8px;\n  padding: 15px;\n  margin: 20px 0;\n  text-align: left;\n  color: rgba(255, 255, 255, 0.8);\n}\n\n.error-details summary {\n  cursor: pointer;\n  color: var(--christmas-gold);\n  font-weight: bold;\n  margin-bottom: 10px;\n}\n\n.error-details pre {\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  font-size: 0.9rem;\n  margin: 10px 0;\n}\n\n.btn {\n  padding: 12px 24px;\n  border: none;\n  border-radius: 8px;\n  font-size: 16px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n}\n\n.btn-primary {\n  background: linear-gradient(135deg, var(--christmas-red), #d32f2f);\n  color: white;\n  box-shadow: 0 4px 15px rgba(196, 30, 58, 0.4);\n}\n\n.btn-primary:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 20px rgba(196, 30, 58, 0.6);\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
